// images
import car from "../assets/projects/car.png";
import kandaflix from "../assets/projects/kandaflix.png";
import ecommerce from "../assets/projects/ecommerce.png";

// icons
import figma from "../assets/icons/figma.png"

const ux = {
  uxs: [
    {
      mainImg: kandaflix,
      name: "Kandaflix Landing Page Design",
      description:
        "KandaFlix, is the ultimate destination for movie lovers. Explore our vast library of films, enjoy seamless navigation, and engage with interactive features that enhance your movie-watching experience. ",
      technologies: [
          {
            name: "FIGMA",
            icon: figma,
          }
        ],
      liveLink:
        "https://www.figma.com/proto/cbPoH5YUwDmed0shRj0gSc/Kandaflix-Landing-page?type=design&node-id=7-2&t=XsqCBW8DRWIzPAZ0-1&scaling=scale-down&page-id=0%3A1&starting-point-node-id=7%3A2&mode=design",
    },
    {
      mainImg: ecommerce,
      name: "E-commerce web Design",
      description:
        "Experience the future of online shopping with our cutting-edge eCommerce website design. Browse a wide array of products, enjoy seamless navigation, and indulge in a streamlined and secure shopping experience. Discover convenience, variety, and quality at your fingertips with our innovative eCommerce platform.",
        technologies: [
          {
            name: "FIGMA",
            icon: figma,
          }
        ],
      liveLink: "https://www.figma.com/proto/ZY3zQc0uF7bRtGws2Brox8/e-comerce-website?type=design&node-id=2-3&t=aAF6xulTywoeox1L-1&scaling=scale-down&page-id=0%3A1&starting-point-node-id=2%3A3&mode=design",
    },
    {
      mainImg: car,
      name: "Car Dealership Mobile App Design",
      description:
        "Discover a sleek and user-friendly UI design for a cutting-edge car dealership. Seamlessly browse a vast selection of vehicles, engage with interactive features, and enjoy a streamlined experience that revolutionizes the way you buy and sell cars.",
        technologies: [
          {
            name: "FIGMA",
            icon: figma,
          }
        ],
      liveLink: "https://www.figma.com/proto/JvoGWmFQB8Ob7GCHg8Lde7/Isuracarhire?type=design&node-id=11-12&t=4a6wv1Kj5vNYiM9P-1&scaling=scale-down&page-id=0%3A1&starting-point-node-id=11%3A12&show-proto-sidebar=1&mode=design",
    },
  ],
};

export default ux;
